import React from "react";

interface TransactionStatusProps {
  status: number;
}

export const TransactionStatus = ({ status }: TransactionStatusProps) => {
  if (status === 0) {
    return (
      <span className=" text-xs font-normal text-red-600"> ✗ Rechazada</span>
    );
  }
  if (status === 1) {
    return (
      <span className=" text-xs font-normal text-green-600">✓ Completada</span>
    );
  }
  if (status === 2) {
    return (
      <span className=" text-xs font-normal text-yellow-600">⚠ Pendiente</span>
    );
  }

  return <div>Sin Status</div>;
};
